import { render, staticRenderFns } from "./ChatroomList.vue?vue&type=template&id=3d3afe0d&"
import script from "./ChatroomList.vue?vue&type=script&lang=js&"
export * from "./ChatroomList.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports